import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";

interface RoleGuardProps {
  requiredRoles: string[];
  children: ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ requiredRoles, children }) => {
  const { hasAnyRole } = useAuth();

  if (hasAnyRole(requiredRoles)) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export default RoleGuard;
